import { SxProps, Theme } from '@mui/material';
import { Colors, inputBackgroundColor } from '../../../constants';

export const coreAutocompleteStyles = (hasValues = false): SxProps<Theme> => ({
	'& .MuiAutocomplete-inputRoot': {
		paddingLeft: '8px',
		py: hasValues ? '5px !important' : '10px !important',
		rowGap: '10px',
		backgroundColor: inputBackgroundColor,

		'&.Mui-focused': {
			'.MuiAutocomplete-clearIndicator': {
				color: Colors.black,
			},
		},

		'&.MuiInputBase-adornedStart .MuiAutocomplete-input, & .MuiAutocomplete-input': {
			padding: `8px 16px 8px ${hasValues ? 10 : 0}px`,
		},

		'& .MuiAutocomplete-endAdornment': {
			top: 'calc(50% + 1px)',
			transform: 'translateY(-50%)',

			'.MuiAutocomplete-popupIndicator, .MuiAutocomplete-clearIndicator': {
				padding: '5px',
				color: 'rgba(0, 0, 0, 0.54)',

				'&.MuiAutocomplete-popupIndicatorOpen': {
					color: Colors.black,
				},

				'&:hover': {
					backgroundColor: Colors.blueTransparentLight,
				},
			},
		},
	},
});

export const autocompleteCheckboxStyles: SxProps<Theme> = {
	// marginLeft: '-13px',
	marginRight: '14px',
	padding: '0',
};
